import { render, staticRenderFns } from "./Coupon.vue?vue&type=template&id=ffd90eca&scoped=true"
import script from "./Coupon.vue?vue&type=script&lang=js"
export * from "./Coupon.vue?vue&type=script&lang=js"
import style0 from "./Coupon.vue?vue&type=style&index=0&id=ffd90eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd90eca",
  null
  
)

export default component.exports